import { render, staticRenderFns } from "./ViewApplicationSuperCR.vue?vue&type=template&id=047a3ce4&scoped=true&"
import script from "./ViewApplicationSuperCR.vue?vue&type=script&lang=js&"
export * from "./ViewApplicationSuperCR.vue?vue&type=script&lang=js&"
import style0 from "./ViewApplicationSuperCR.vue?vue&type=style&index=0&id=047a3ce4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a3ce4",
  null
  
)

export default component.exports